module.exports = __webpack_public_path__ + "static/img/3.3debe47.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/objectRecognition/ios/3.png
// module id = cVqb
// module chunks = 1